import React from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArtstation, faBehance, faLinkedin, faInstagram, faTwitter, faSpotify, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt, faLink } from '@fortawesome/free-solid-svg-icons';

import { Section, Layout, SEO } from '..';
import { Fiverr } from '../icons';

import superheroes from './assets/superheroes.png';
import adrian from './assets/adrian.png';
import adam from './assets/adam.png';
import karolina from './assets/karolina.png';
import tomasz from './assets/tomasz.png';
import michalSlawinski from './assets/michalSlawinski.png';
import michalPasierbiewicz from './assets/michalPasierbiewicz.png';
import michalBonczyk from './assets/michalBonczyk.png';
import robert from './assets/robert.png';

import style from './AboutUsPage.module.less';

export const AboutUsPage = () => (
  <Layout>
    <SEO title="About us" description="We are a group of five friends, from Poland and Scotland, who connected through our love of games and puzzles." />

    <Section className={classnames(style.section, style.firstSection)}>
      <div className={style.content}>
        <h1>About us</h1>

        <div className={classnames(style.row, style.full)}>
          <div className={style.image}>
            <img src={superheroes} alt="Team of superheroes" />
          </div>
          <div className={style.text} style={{ textAlign: "center" }}>
            <p>Passionate people connected through our love of games and puzzles.</p>
          </div>
        </div>

        <div className={classnames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Adrian</h2>
            <ul className={style.social}>
              <li><a href="https://www.linkedin.com/in/adrianolczyk/" target="_blank" title="LinkedIn"><FontAwesomeIcon className={style.icon} icon={faLinkedin} /></a></li>
              <li><a href="https://twitter.com/AdrianOlczyk" target="_blank" title="Twitter"><FontAwesomeIcon className={style.icon} icon={faTwitter} /></a></li>
              <li><a href="https://www.instagram.com/adrian.olczyk/" target="_blank" title="Instagram"><FontAwesomeIcon className={style.icon} icon={faInstagram} /></a></li>
            </ul>
            <p>Has a background in software engineering and management. His passion for creating fun and challenging games was inspired by his own experiences and drive to create the type of games he would like to play. His skills are invaluable to our company but, when he does take some down time, mountain biking is his passion.</p>
            <p>His favourite board game is Talisman and video game - XCOM 2.</p>
          </div>
          <div className={style.image}>
            <img src={adrian} alt="Adrian" />
          </div>
        </div>

        <div className={classnames(style.row)}>
          <div className={style.text}>
            <h2>Karolina</h2>
            <p>A scientist, this smart cookie has plenty of drive and energy, which she channels into developing our company. When she eventually takes a break from her busy schedule, she enjoys swimming and hiking.</p>
            <p>Her favourite board game is Azul and video game - Sanitarium.</p>
          </div>
          <div className={style.image}>
            <img src={karolina} alt="Karolina" />
          </div>
        </div>

        <div className={classnames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Adam</h2>
            <ul className={style.social}>
              <li><a href="https://www.linkedin.com/in/adam-kabalak-1338946b" target="_blank" title="LinkedIn"><FontAwesomeIcon className={style.icon} icon={faLinkedin} /></a></li>
              <li><a href="https://www.artstation.com/adam_kabalak" target="_blank" title="ArtStation"><FontAwesomeIcon className={style.icon} icon={faArtstation} /></a></li>
              <li><a href="https://www.fiverr.com/adamkabalak" target="_blank" title="Fiverr" className={style.fiverr}><Fiverr height={27} width={27} /></a></li>
              <li><a href="https://www.behance.net/adamk8" target="_blank" title="Behance"><FontAwesomeIcon className={style.icon} icon={faBehance} /></a></li>
            </ul>
            <p>A busy father of two, he is a freelance artist who has the ability to create amazing characters and worlds, as he often does when drawing comics with his youngest son. All the art in the game has been done by Adam and it transformed the game completely. In his free time he likes to walk his dog, drink beer and read books (not at the same time).</p>
            <p>Given his busy life Adam doesn’t get much time to play board games outside of those with his kids (such as Memo and Snail Races) and when time allows he dives back into his favourites from yesteryear such as Quake or Samurai Showdown but also enjoys games like Doom 3 (which is as recent as they get for him).</p>
          </div>
          <div className={style.image}>
            <img src={adam} alt="Adam" />
          </div>
        </div>

        <div className={classnames(style.row)}>
          <div className={style.text}>
            <h2>Michał</h2>
            <ul className={style.social}>
              <li><a href="https://github.com/MichalSlawin?tab=repositories" target="_blank" title="GitHub"><FontAwesomeIcon className={style.icon} icon={faGithub} /></a></li>
              <li><a href="https://play.unity.com/u/Micherman" target="_blank" title="Unity Play"><FontAwesomeIcon className={style.icon} icon={faLink} /></a></li>
              <li><a href="https://pl.linkedin.com/in/michał-sławiński-961662196" target="_blank" title="Twitter"><FontAwesomeIcon className={style.icon} icon={faLinkedin} /></a></li>
            </ul>
            <p>Programmer with a passion for games from an early age. To compensate for the large amount of time spent in front of the screen, he stays fit by running and going to the gym.</p>
            <p>He also loves music and used to learn to play piano and guitar.</p>
            <p>His favorite board game is Carcassonne and video game - Deep Rock Galactic.</p>
          </div>
          <div className={style.image}>
            <img src={michalSlawinski} alt="Michał Sławiński" />
          </div>
        </div>

        <div className={classnames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Michał</h2>
            <ul className={style.social}>
              <li><a href="https://github.com/Michal314-p?tab=repositories" target="_blank" title="GitHub"><FontAwesomeIcon className={style.icon} icon={faGithub} /></a></li>
              <li><a href="https://pl.linkedin.com/in/michał-pasierbiewicz-50ab39212" target="_blank" title="LinkedIn"><FontAwesomeIcon className={style.icon} icon={faLinkedin} /></a></li>
            </ul>
            <p>A programmer with a background in software engineering and passion for games. He has two cats that give him energy and inspiration. Additionally, he enjoys diving into the lore of fantasy universes such as Warhammer and Forgotten Realms.</p>
            <p>His favorite games are Total War: Warhammer and Stellaris.</p>
          </div>
          <div className={style.image}>
            <img src={michalPasierbiewicz} alt="Michał Pasierbiewicz" />
          </div>
        </div>

        <div className={classnames(style.row)}>
          <div className={style.text}>
            <h2>Robert</h2>
            <ul className={style.social}>
              <li><a href="https://www.artstation.com/kometan" target="_blank" title="ArtStation"><FontAwesomeIcon className={style.icon} icon={faArtstation} /></a></li>
            </ul>
            <p>Never grew out of his first childhood dream of working on games. 2D and 3D artist, steadily branching out and polishing his skills on a quest to become a one man army in art. Hopes that one day his skillset will be as diverse as his taste in games, as his favorites range from the entire Resident Evil franchise to Sea of Thieves or Lego video games.</p>
          </div>
          <div className={style.image}>
            <img src={robert} alt="Robert" />
          </div>
        </div>

        <div className={classnames(style.row, style.alternate)}>
          <div className={style.text}>
            <h2>Michał</h2>
            <ul className={style.social}>
              <li><a href="https://www.artstation.com/user-5263473" target="_blank" title="ArtStation"><FontAwesomeIcon className={style.icon} icon={faArtstation} /></a></li>
            </ul>
            <p>Game designer and father, Michał is a man of many passions and peculiarities. A hobbyist painter and laureate of a few literary contests, a statistics and riddle nerd, long-time tabletop RPG player, game modder, and organizer of fantasy conventions with a background in land engineering, he has a skillset as diverse as it gets.</p>
            <p>Michał likes many games, especially 4X, grand strategy, and base builders, namely Europa Universalis IV, Stellaris, and Dwarf Fortress, to name a few.</p>
          </div>
          <div className={style.image}>
            <img src={michalBonczyk} alt="Michał Bończyk" />
          </div>
        </div>

        <div className={classnames(style.row)}>
          <div className={style.text}>
            <h2>Tomasz</h2>
            <ul className={style.social}>
              <li><a href="https://tomarkusmusic.com/" target="_blank" title="Tomarkus Music"><FontAwesomeIcon className={style.icon} icon={faLink} /></a></li>
              <li><a href="https://twitter.com/TomarkusMusic" target="_blank" title="Twitter"><FontAwesomeIcon className={style.icon} icon={faTwitter} /></a></li>
              <li><a href="https://open.spotify.com/artist/7nfzKPCX0akVb6EXpr59Kp?si=eFRHcrNqRECo1BQgo48UfQ&nd=1" target="_blank" title="Spotify"><FontAwesomeIcon className={style.icon} icon={faSpotify} /></a></li>
            </ul>
            <p>Professionally associated with software quality assurance. A man of many different hobbies - old computers enthusiast (mainly Amiga, Atari, Commodore) and computer demoscene enthusiast. Landscape photographer. A sound engineer and composer in one for over 20 years.</p>
            <p>Favorite board game - Talisman (with all expansions). Favorite games - almost all games from the non-existent Bullfrog Productions studio: Syndicate, Theme Hospital, Populous, Dungeon Keeper.</p>
          </div>
          <div className={style.image}>
            <img src={tomasz} alt="Tomasz" />
          </div>
        </div>

      </div>

      <h1>Contact</h1>

      <div className={style.row}>
        <div className={style.text}>
          <h2>Company</h2>

          <p>
            Eleven Products Sp. z o.o. <br />
            ul. Domki 14<br />
            31-519 Kraków<br />
            Poland
          </p>

          <p>VAT: PL6793208772</p>

          <h2>Get in touch</h2>

          <p>You can reach us at <a href="mailto:contact@elevenpuzzles.com">contact@elevenpuzzles.com</a> or via <a href="https://www.facebook.com/elevenpuzzles/" target="_blank">Facebook</a> and <a href="https://www.instagram.com/elevenpuzzles/" target="_blank">Instagram</a>.</p>

          <p>We'll answer as soon as possible, however please remember that we might be in a different timezone than you - we're based in Poland.</p>
        </div>
      </div>
    </Section>
  </Layout>
);
